"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const AvatarComponent_1 = __importDefault(require("@Components/AvatarComponent"));
const TagsBlock_1 = __importDefault(require("@Components/UserRowComponent/TagsBlock"));
const UserInfoBlock = (props) => {
    const { firstName, lastName, groups } = props.userData;
    return (react_1.default.createElement("div", { className: "user-info" },
        react_1.default.createElement(AvatarComponent_1.default, { firstName: firstName, lastName: lastName, small: true }),
        react_1.default.createElement("div", { className: 'name-block' },
            react_1.default.createElement("h5", { title: firstName + ' ' + lastName },
                firstName,
                " ",
                lastName),
            react_1.default.createElement(TagsBlock_1.default, { groups: groups }))));
};
exports.default = UserInfoBlock;
